<template>
  <v-container class="pa-5" fluid>
    <v-card>
      <v-card-title>Ip Address Lists</v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              :placeholder="`Search`"
              :hide-details="true"
              solo
              clearable
              @input="onGridSearch"
              v-model="keyword"
              autocomplete="off"
              color="dark"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-select
              :items="stateFilterOptions"
              label="State"
              v-model="stateFilter"
              @change="onGridSearch"
              color="dark"
            ></v-select>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-select
              :items="typeOptions"
              label="Type"
              v-model="typeFilter"
              @change="onGridSearch"
              color="dark"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-select
              :items="listSize"
              label="No. of Rows"
              v-model="pageSize"
              color="dark"
            ></v-select>
          </v-col>
          <v-col cols="12" class="py-0">
            <div class="filter-actions">
              <div class="status-switches">
                <v-switch
                  label="Show Quarantined"
                  v-model="showQuarantined"
                  @change="onGridSearch"
                  color="dark"
                  hide-details
                ></v-switch>
                <v-switch
                  label="Show Assigned"
                  v-model="showAssigned"
                  @change="onGridSearch"
                  color="dark"
                  hide-details
                ></v-switch>
                <v-switch
                  label="Show Available"
                  v-model="showAvailable"
                  @change="onGridSearch"
                  color="dark"
                  hide-details
                ></v-switch>
              </div>
              <div class="action-buttons">
                <v-btn color="dark" dark @click="onExport">Export data</v-btn>
                <v-btn
                  v-if="isAdmin"
                  color="dark"
                  dark
                  @click="showAdd"
                >Import Ip Address</v-btn>
                <v-btn
                  v-if="isAdmin"
                  color="dark"
                  dark
                  @click="triggerConfirm"
                >Release Ip Address</v-btn>
                <v-checkbox
                  v-if="isAdmin"
                  v-model="isImmediateRelease"
                  label="Immediate IP Release"
                  hide-details
                ></v-checkbox>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <ag-grid-vue
              class="ag-theme-alpine"
              style="height: 60vh"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="rowData"
              :gridOptions="gridOptions"
              :pagination="true"
              :paginationPageSize="rowsPerPage"
              :overlayNoRowsTemplate="noRowsTemplate"
              rowSelection="single"
              @row-selected="onRowSelected"
              @grid-ready="onGridReady"
              @grid-size-changed="onGridSizeChanged"
              @cell-clicked="onCellClicked"
            >
            </ag-grid-vue>
          </v-col>
        </v-row>

        <v-dialog v-model="editing" width="20vw" persistent>
          <edit-ip
            v-if="editing"
            ref="editIp"
            @saved="saved"
            @cancel="cancel"
          ></edit-ip>
        </v-dialog>
        <confirm
          :dialog="dialogRelease"
          :text="`You are about to release Quarantined ip address. Do you want to proceed?`"
          :proceedText="`Yes`"
          :cancelText="`Cancel`"
          @onBtnClick="release"
        ></confirm>
        <v-dialog v-model="editingState" width="400" persistent>
          <v-card>
            <v-card-title>Edit State</v-card-title>
            <v-divider class="mx-4 mb-2"></v-divider>
            <v-card-text>
              <div class="mb-2">IP: {{ editStateIp }}</div>
              <v-select
                label="State"
                placeholder="Select State"
                outlined
                v-model="editStateValue"
                :items="stateOptions"
                item-text="text"
                item-value="value"
                color="dark"
              ></v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="dark" dark @click="saveState">Save</v-btn>
              <v-btn @click="editingState = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import UserService from "@/models/UserService";
import confirm from "@/components/confirm";
import { stateOptions } from "@/config/stateOptions";
import {
  buildIpAddressSearch,
  gridPageSize,
  stateFilterOptions,
  typeOptions,
} from "@/utils/ipAddressSearch";

export default {
  name: "IpAddressList",
  data: () => ({
    userService: new UserService(),
    columnDefs: [
      { headerName: "Ip Address", field: "ip" },
      { headerName: "Status", field: "status" },
      { headerName: "State", field: "state" },
      { headerName: "Quarantined Date", field: "quarantinedDate" },
    ],
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    showDeleted: false,
    showQuarantined: false,
    showAssigned: false,
    showAvailable: true,
    stateFilter: "",
    typeFilter: "",
    stateFilterOptions,
    typeOptions,
    editing: false,
    rowData: [],
    noRowsTemplate:
      '<span class="ag-overlay-no-rows-center">No IP addresses match these filters</span>',
    gridApi: null,
    gridColumnApi: null,
    // Quiet until the first answer: before that an empty grid is not "no matches".
    gridOptions: { suppressNoRowsOverlay: true },
    keyword: "",
    pageSize: 50,
    dialogRelease: false,
    listSize: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "Show All",
        value: -1,
      },
    ],
    isImmediateRelease: false,
    editingState: false,
    editStateId: null,
    editStateIp: '',
    editStateValue: null,
    stateOptions,
  }),
  components: { AgGridVue,confirm },
  computed: {
    // The grid pages the rows on the client; No. of Rows is the page size.
    rowsPerPage() {
      return gridPageSize(this.pageSize, (this.rowData || []).length);
    },
  },
  watch: {
    // The grid reads :paginationPageSize at start-up only, later sizes go through its api.
    rowsPerPage(size) {
      if (this.gridApi) this.gridApi.paginationSetPageSize(size);
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    if (this.isAdmin) {
      this.columnDefs.push({
        headerName: "",
        colId: "actions",
        width: 60,
        suppressSizeToFit: true,
        sortable: false,
        filter: false,
        cellRenderer: (params) => {
          if (params.data && params.data.status === "Available") {
            return '<span style="cursor:pointer;font-size:16px;" title="Edit State">&#9998;</span>';
          }
          return '';
        },
      });
    }
  },
  methods: {
    manageRow(item) {
      let vm = this;
      vm.pageSize(item).then((data) => {
        vm.rowData = data;
        vm.gridApi.sizeColumnsToFit();
      });
    },
    triggerConfirm() {
      let vm = this;
      console.log("clicked");
      vm.dialogRelease = true;
    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      args.api.sizeColumnsToFit();
    },
    onGridSizeChanged(args) {
      // The grid width follows the window and the side menu; keep the columns filling it.
      if (args.clientWidth > 0) args.api.sizeColumnsToFit();
    },
    onRowSelected(data) {
      let vm = this;
      // vm.setAvailableService(data.data);
      // vm.$router.push(`/service-details/${data.data.radiusServiceId}`);
    },
    onGridSearch() {
      let vm = this;

      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        vm.loadIpAddresses().catch(() => {});
      }, 500);
    },
    loadIpAddresses() {
      let vm = this;
      return vm
        .getIpAddresses(
          buildIpAddressSearch({
            keyword: vm.keyword,
            showAvailable: vm.showAvailable,
            showAssigned: vm.showAssigned,
            showQuarantined: vm.showQuarantined,
            state: vm.stateFilter,
            type: vm.typeFilter,
          })
        )
        .then((data) => {
          // No rows matching comes back as no data at all.
          vm.gridOptions.suppressNoRowsOverlay = false;
          vm.rowData = data || [];
          if (vm.gridApi) {
            vm.$nextTick(() => {
              // New rows start on page 1, not on the page number the old rows were on.
              vm.gridApi.paginationGoToFirstPage();
              // Fit once the rows are drawn: a vertical scrollbar takes part of the width.
              vm.gridApi.sizeColumnsToFit();
            });
          }
        });
    },
    onExport() {
      let vm = this;
      vm.gridApi.exportDataAsCsv();
    },
    showAdd() {
      let vm = this;
      vm.editing = true;
    },

    retrieveIp() {
      let vm = this;
      vm.loadIpAddresses().catch(() => {
        // vm.store.dispatch("auth/authenticate");
      });
    },
    cancel() {
      let vm = this;
      vm.editing = false;
    },

    saved() {
      let vm = this;
      vm.editing = false;
      vm.retrieveIp();
    },

    onCellClicked(params) {
      if (params.column.colId === 'actions' && params.data && params.data.status === 'Available') {
        this.showEditState(params.data);
      }
    },
    showEditState(row) {
      this.editStateId = row.id;
      this.editStateIp = row.ip;
      this.editStateValue = row.state;
      this.editingState = true;
    },
    saveState() {
      let vm = this;
      vm.updateIpAddressState({ id: vm.editStateId, state: vm.editStateValue })
        .then(() => {
          vm.editingState = false;
          vm.retrieveIp();
        })
        .catch(() => {});
    },
    release(args) {
      let vm = this;
      if(args)
      {
        vm.releaseIpAddres(vm.isImmediateRelease)
          .then((data) => {
          })
          .catch(() => {
          });
      }
      vm.dialogRelease = false;

    },

  },
  beforeMount() {
    let vm = this;
    vm.retrieveIp();
    vm.search = 50;
  },
}
</script>

<style scoped>
.filter-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.status-switches {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.status-switches > * {
  margin: 8px 24px 8px 0;
  padding-top: 0;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}

.action-buttons > * {
  margin: 8px 0 8px 16px;
  padding-top: 0;
}

@media (max-width: 599.98px) {
  .action-buttons {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .action-buttons > * {
    margin-left: 0;
  }
}
</style>
